export const TRANSCRIPT_SEGMENT_STATUS = {
	PENDING: 'pending',
	TRANSCRIBING: 'transcribing',
	FINAL: 'final',
	FAILED: 'failed',
}

export const TRANSCRIPT_STATUS = {
	IDLE: 'idle',
	STREAMING: 'streaming',
	DRAINING: 'draining',
	COMPLETE: 'complete',
	ERROR: 'error',
}

export const CHUNK_TIMESLICE_MS = 3000

export {
	TRANSCRIPT_WINDOW_STEADY_MS,
	TRANSCRIPT_WINDOW_WARMUP_MS,
	getTranscriptWindowMs,
} from '../utils/getTranscriptWindowMs'

export function createRecordingId() {
	return `rec-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}

export function createTranscriptSegment({
	chunkId,
	text = '',
	startMs = 0,
	endMs = 0,
	speaker = null,
	status = TRANSCRIPT_SEGMENT_STATUS.PENDING,
	error = null,
} = {}) {
	return {
		chunkId: Number(chunkId),
		text: String(text || ''),
		startMs: Number(startMs) || 0,
		endMs: Number(endMs) || 0,
		speaker: speaker ?? null,
		status,
		...(error ? { error } : {}),
	}
}
